import { render, staticRenderFns } from "./acquistarecasa.vue?vue&type=template&id=4e435165"
import script from "./acquistarecasa.vue?vue&type=script&lang=js"
export * from "./acquistarecasa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports